import { GET_ALL_LISTINGS } from "./types";

const initialState = {
}

const listingsReducer = (state = initialState, action) => {
    if (action.type) {
        switch (action.type) {
            case GET_ALL_LISTINGS:
                return {
                    ...state,
                    allListingsSearch: action.payload
                }
            default:
                {
                    return state;
                }
        }
    }
}

export default listingsReducer;